/* HUMAN MATTER — community fan (sections/elora-community-cta.liquid).
   Turns the deck: every `interval` seconds the card in slot 0 leaves (.is-leaving) and every other
   card moves one slot down, so a waiting card enters slot 4 from the right; CSS draws the arc from
   data-slot. Runs while the section is on screen and the tab is visible; a mouse resting over the
   fan holds it (touch and focus do not); the arrows, the keys and a swipe step the deck by hand and
   rest it for max(4 s, 4 × interval), then it turns again (Kamil 11.09: keeps turning, stops under the mouse; 0.5 s = a continuous flow).
   Reduced motion: no auto-turn.
   Idempotent per section, re-inits on shopify:section:load, tears down on unload; the Theme Editor's
   block select centres that photo. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var wide = window.matchMedia('(min-width: 750px)');
  var VISIBLE_WIDE = 5;
  var VISIBLE_NARROW = 3;

  function initRoot(root) {
    if (root.dataset.eloraCfanReady) return;
    var cards = [].slice.call(root.querySelectorAll('[data-cfan-card]'));
    if (cards.length < 2) return;
    root.dataset.eloraCfanReady = '';
    var n = cards.length;
    var offset = 0; /* index of the card in slot 0 */
    var timer = 0;
    var restTimer = 0;
    var resting = false; /* the visitor just stepped the deck by hand: rest, then turn again */
    var hovered = false; /* a mouse pointer is over the fan */
    var onScreen = false;
    var interval = Math.max(0.5, parseFloat(root.getAttribute('data-interval')) || 0.5) * 1000;
    var slide = Math.max(0.3, parseFloat(root.getAttribute('data-transition')) || 0.7) * 1000; /* = --cfan-t, set by the section */
    var REST = Math.max(4000, interval * 4);
    root.dataset.cfanRest = String(REST);
    var listeners = [];

    function on(el, ev, fn, opts) {
      el.addEventListener(ev, fn, opts);
      listeners.push([el, ev, fn, opts]);
    }

    function visibleCount() {
      return wide.matches ? VISIBLE_WIDE : VISIBLE_NARROW;
    }

    var leaveTimers = [];
    function render(leaving) {
      var vis = visibleCount();
      cards.forEach(function (card, i) {
        var slot = (i - offset + n) % n;
        card.setAttribute('data-slot', String(slot));
        if (slot < vis) card.removeAttribute('aria-hidden');
        else card.setAttribute('aria-hidden', 'true');
      });
      if (leaving) {
        /* at a fast cadence several cards fade out at once: each keeps .is-leaving for its own slide time */
        leaving.classList.add('is-leaving');
        leaveTimers.push(window.setTimeout(function () { leaving.classList.remove('is-leaving'); }, slide + 100));
      }
      if (leaveTimers.length > 40) leaveTimers = leaveTimers.slice(-40);
    }

    function step(dir) {
      var leaving = dir > 0 ? cards[offset] : null;
      offset = (offset + dir + n) % n;
      render(leaving);
    }

    function stop() {
      window.clearInterval(timer);
      timer = 0;
    }

    function play() {
      if (timer || resting || hovered || !onScreen || reduce.matches || document.hidden) return;
      timer = window.setInterval(function () { step(1); }, interval);
    }

    function pause() {
      stop();
    }

    function rest() {
      resting = true;
      stop();
      window.clearTimeout(restTimer);
      restTimer = window.setTimeout(function () { resting = false; play(); }, REST);
    }

    /* ------------------------------------------------ controls: arrows, keys, swipe */
    var prev = root.querySelector('[data-cfan-prev]');
    var next = root.querySelector('[data-cfan-next]');
    function takeOver(dir) {
      rest();
      step(dir);
    }
    if (prev) on(prev, 'click', function () { takeOver(-1); });
    if (next) on(next, 'click', function () { takeOver(1); });

    var stage = root.querySelector('[data-cfan-stage]') || root;
    var startX = null;
    on(stage, 'pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button === 0) startX = e.clientX; }, { passive: true });
    on(stage, 'pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) takeOver(dx < 0 ? 1 : -1);
    }, { passive: true });
    on(stage, 'pointercancel', function () { startX = null; }, { passive: true });
    on(stage, 'keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); takeOver(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); takeOver(1); }
    });

    /* ------------------------------------------------ autoplay gates: mouse over the fan, on screen, tab visible */
    on(stage, 'pointerenter', function (e) { if (e.pointerType === 'mouse') { hovered = true; pause(); } });
    on(stage, 'pointerleave', function (e) { if (e.pointerType === 'mouse') { hovered = false; play(); } });
    on(document, 'visibilitychange', function () { if (document.hidden) pause(); else play(); });
    on(wide, 'change', function () { render(null); });
    on(reduce, 'change', function () { if (reduce.matches) pause(); else play(); });

    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        onScreen = entries.some(function (e) { return e.isIntersecting; });
        if (onScreen) play(); else pause();
      }, { threshold: 0.25 });
      io.observe(root);
    } else {
      onScreen = true;
      play();
    }

    render(null);

    /* ------------------------------------------------ Theme Editor */
    function centreBlock(e) {
      var card = e.target && e.target.closest ? e.target.closest('[data-cfan-card]') : null;
      var i = cards.indexOf(card);
      if (i < 0) return;
      rest();
      var centre = wide.matches ? 2 : 1;
      offset = (i - centre + n) % n;
      render(null);
    }
    on(document, 'shopify:block:select', centreBlock);

    root.eloraCfanTeardown = function () {
      stop();
      leaveTimers.forEach(function (id) { window.clearTimeout(id); });
      window.clearTimeout(restTimer);
      if (io) io.disconnect();
      listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
      listeners = [];
      delete root.dataset.eloraCfanReady;
    };
  }

  function init(scope) {
    var r = scope && scope.querySelectorAll ? scope : document;
    [].slice.call(r.querySelectorAll('[data-elora-cfan]')).forEach(initRoot);
    if (r.matches && r.matches('[data-elora-cfan]')) initRoot(r);
  }

  function drop(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var roots = [].slice.call(scope.querySelectorAll('[data-elora-cfan]'));
    if (scope.matches && scope.matches('[data-elora-cfan]')) roots.push(scope);
    roots.forEach(function (root) { if (root.eloraCfanTeardown) root.eloraCfanTeardown(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
  document.addEventListener('shopify:section:unload', function (e) { drop(e.target); });
})();
